var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{},[_c('app-navbar'),_c('div',{staticClass:"app-content"},[_vm._t("default")],2),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }